export default class PostTile {
  bgColor?: string;

  fontFamily?: string;
}
